/**
 * Messages FR de l'éditeur de template de charte graphique
 */

module.exports = {

    mobileWarning: {
        title: 'Votre navigateur est trop petit !',
        description: 'Tookano est seulement accessible sur votre ordinateur portable ou de bureau. La largeur de fenêtre de votre navigateur doit être d\'au moins 992px.'
    },

    watermarkMessage: 'Le filigrane Tookano sur l\'image, qui protège les droits d\'auteur, disparaitra à la diffusion sur vos réseaux sociaux. De la même manière, la résolution de l\'image est automatiquement ajustée à la diffusion.',

    node: {
        text: {
            defaultText: 'Entrez votre texte ici'
        },
        publicationImageInformationNodeText: 'Image dynamique générée automatiquement en fonction du sujet'
    },

    lateralMenu: {
        design: {
            label: 'Modèle Graphique'
        },
        text: {
            label: 'Texte'
        },
        shape: {
            label: 'Forme',
        },
        brand: {
            label: 'Marque'
        },
        media: {
            label: 'Média'
        }
    },

    sidePanel: {
        design: {
            title: 'Modèle graphique',
            tabMenu: {
                single: 'Image fixe',
                carousel: 'Carrousel'
            },
            buttons: {
                addCharter: {
                    single: 'Ajouter un modèle',
                    carousel: 'Ajouter un modèle'
                },
                manageThemes: 'Types de contenus'
            },
            manageThemes: {
                description: 'Gérer les types de contenus afin d\'associer un modèle à ce contenu.'
            },
            templateList: {
                title: 'Tous les modèles'
            }
        },
        text: {
            title: 'Texte',
            buttons: {
                addText: 'Ajouter une zone de texte'
            },
            dynamicText: {
                title: 'Texte dynamiques prédéfinis',
                tooltip: 'Un texte dynamique est une zone de texte dont le contenu sera généré automatiquement par l\'IA, de manière différente pour chaque post, en fonction du prompte qui sera renseigné.',
                types: {
                    heading: 'Ajouter un titre',
                    subheading: 'Ajouter un sous-titre',
                    description: 'Ajouter du corps de texte'
                },
                parameters: {
                    title: 'Personnaliser mon prompt',
                    fields: {
                        prompt: {
                            label: 'Décrivez le prompt qui sera utilisé pour rédiger votre contenu.',
                            placeholder: 'Par exemple : « Un titre accrocheur résumant l’accroche du post » ou : « Un titre pour un Call to Action pour générer du trafic sur mon site »'
                        },
                        maxCharacters: {
                            label: 'Nombre de caractères :'
                        },
                        contentType: {
                            label: 'Type',
                            default: 'Sélectionner un type',
                            options: {
                                heading1: 'Titre',
                                heading2: 'Sous-titre',
                                description: 'Description'
                            }
                        }
                    },
                    buttons: {
                        addNode: 'Ajouter un texte dynamique',
                        updateNode: 'Modifier le texte dynamique'
                    }
                }
            }
        },
        shape: {
            title: 'Formes',
            baseShapes: {
                title: 'Formes de base'
            },
            baseLines: {
                title: 'Lignes de base'
            },
            customerShapes: {
                title: 'Mes formes',
                edit: {
                    form: {
                        error: 'Une erreur s\'est produite pendant l\'enregistrement de la forme.',
                        fieldset: {
                            shape: {
                                title: 'Forme { position }'
                            }
                        },
                        fields: {
                            name: 'Nom de la forme',
                            file: 'Fichier de la forme',
                        }
                    },
                    modal: {
                        titleWithName: 'Édition de la form { shape }',
                        titleWithoutName: 'Édition d\'une forme'
                    },
                    button: {
                        edit: {
                            altLabel: 'Éditer la forme'
                        }
                    }
                },
                add: {
                    modal: {
                        title: 'Ajout d\'une forme',
                        form: {
                            button: {
                                addAnotherShape: {
                                    label: 'Ajouter une autre forme'
                                }
                            }
                        }
                    },
                    button: {
                        add: {
                            label: 'Ajouter une forme'
                        }
                    }
                }
            },
            svgShapes: {
                title: 'Autres formes'
            }
        },
        brand: {
            title: 'Marque',
            buttons: {
                goToAccount: {
                    label: 'Configurer votre marque'
                }
            },
            logo: {
                title: 'Logo',
                buttons: {
                    add: {
                        label: 'Ajouter un logo'
                    }
                },
                uploadLogo: {
                    error: 'Une erreur s\'est produite pendant la mise à jour du logo.'
                },
                additionalLogo: {
                    error: 'Une erreur s\'est produite pendant le téléchargement du logo.'
                }
            },
            colors: {
                title: 'Palette de couleurs',
                updateColors: {
                    error: 'Une erreur s\'est produite pendant la mise à jour des couleurs.'
                }
            },
            fonts: {
                title: 'Typographies',
                buttons: {
                    add: {
                        heading1: {
                            label: 'Ajouter une typographie pour les titres'
                        },
                        heading2: {
                            label: 'Ajouter une typographie pour les sous-titres'
                        },
                        description: {
                            label: 'Ajouter une typographie pour les descriptions'
                        }
                    }
                }
            }
        },
        media: {
            title: 'Média',
            library: {
                title: {
                    label: 'Vos images',
                    tooltip: 'Téléchargez vos images. Elles seront affichées automatiquement en priorité dans les Images Suggérées, si le sujet d\'un post correspond à l\'une d\'entre elles. Cela vous fera gagner beaucoup de temps'
                },
                empty: 'Aucune image n\'a été trouvée.'
            },
            imagesBank: {
                title: {
                    label: 'Banque d\'images',
                    tooltip: 'Il s\'agit d\'images provenant d\'un partenaire. Les droits de licence d\'exploitation pour vos réseaux sociaux sont compris dans votre forfait'
                }
            },
            dynamicImages: {
                title: 'Images dynamiques',
                description: 'Une image dynamique est un visuel qui changera automatiquement en fonction du sujet de la publication.',
                preview: {
                    title: 'Image dynamique',
                    description: 'Visuel généré de manière automatique suivant le sujet abordé'
                }
            },
            aiImages: {
                title: {
                    label: 'Images IA',
                    tooltip: 'Sélectionne une image et demande à l\'IA de changer des éléments sur l\'image. Ou bien ne sélectionne aucune image et demande à l\'IA de créer une nouvelle image à partir d\'un nouveau prompt'
                },
                error: 'Une erreur s\'est produite pendant la génération des images.',
                prompt: {
                    placeholder: 'Décrivez l\'image que vous souhaitez.'
                },
                legalMessage: 'Les images ci-dessous sont générées par l\'intelligence artificielle',

                enrichPrompt: 'Demande à l\'IA d\'enrichir ton prompt',

                buttons: {
                    search: {
                        label: 'Rechercher'
                    }
                }
            },
            suggestedMedias: {
                title: {
                    label: 'Médias suggérés',
                    tooltip: 'Il s\'agit d\'une suggestion d\'images en rapport avec l\'idée du post'
                }
            },
            buttons: {
                addMedias: {
                    label: 'Importer des medias'
                },
                importImage: {
                    label: 'Importer une image'
                }
            }
        }
    },

    content: {
        header: {
            defaultTemplateName: 'Nom du modèle graphique',
            save: {
                error: 'Une erreur s\'est produite pendant l\'enregistrement'
            },
            exit: {
                confirmation: {
                    message: 'Êtes-vous sûr de vouloir fermer l\'éditeur ?',
                    buttons: {
                        save: 'Sauvegarder et quitter',
                        exit: 'Quitter sans sauvegarder'
                    }
                }
            }
        },
        toolbar: {
            background: {
                altLabel: 'Arrière plan'
            },
            opacity: {
                altLabel: 'Transparence',
                label: 'Transparence'
            },
            rotation: {
                altLabel: 'Retourner et pivoter',
                label: 'Rotation',
                return: {
                    label: 'Retourner',
                    horizontal: 'Horizontalement',
                    vertical: 'Verticalement'
                },
                rotate: {
                    label: 'Pivoter',
                    toLeft: 'À droite de 90°',
                    toRight: 'À gauche de 90°'
                }
            },
            depth: {
                title: 'Organiser',
                altLabel: 'Organiser',
                moveUp: 'Déplacer en avant',
                moveDown: 'Déplacer en arrière',
                moveFront: 'Déplacer au premier plan',
                moveBack: 'Déplacer à l’arrière plan'
            },
            align: {
                title: 'Aligner sur la page',
                altLabel: 'Aligner',
                top: 'Haut',
                left: 'Gauche',
                center: 'Centre',
                bottom: 'Bas',
                right: 'Droite'
            },
            shape: {
                background: {
                    altLabel: 'Arrière plan'
                },
                border: {
                    altLabel: 'Style de bordure',
                    width: {
                        title: 'Épaisseur de la bordure'
                    },
                    radius: {
                        title: 'Arrondi des angles'
                    },
                    color: {
                        altLabel: 'Couleur de bordure'
                    }
                },
                mask: {
                    altLabel: 'Masque : rend la forme transparente'
                }
            },
            text: {
                fontFamily: {
                    title: 'Typographie',
                    buttons: {
                        add: {
                            label: 'Ajouter une typo'
                        }
                    }
                },
                fontSize: {
                    altLabel: 'Taille de police'
                },
                color: {
                    altLabel: 'Couleur du texte'
                },
                bold: {
                    altLabel: 'Gras'
                },
                italic: {
                    altLabel: 'Italique'
                },
                underline: {
                    altLabel: 'Souligner'
                },
                align: {
                    altLabel: 'Alignement',
                    menu: {
                        horizontal: {
                            title: 'Horizontal',
                            types: {
                                left: 'Gauche',
                                center: 'Centrer',
                                right: 'Right',
                                justify: 'Justifier'
                            }
                        },
                        vertical: {
                            title: 'Vertical',
                            types: {
                                top: 'Haut',
                                middle: 'Milieu',
                                bottom: 'Bas'
                            }
                        },
                    }
                },
                spacing: {
                    altLabel: 'Espacement',
                    letter: {
                        label: 'Lettres'
                    },
                    lineHeight: {
                        label: 'Interlignage'
                    }
                }
            },
            svg: {
                color: {
                    altLabel: 'Couleur de fond de la forme'
                }
            },
            remove: {
                altLabel: 'Supprimer'
            },
            duplicate: {
                altLabel: 'Dupliquer'
            },
            lock: {
                altLabel: 'Verrouiller'
            }
        },

        color: {
            societyColors: {
                title: 'Couleurs de marque'
            },
            recentColor: {
                label: 'Couleur récente'
            },
            customerColorIndex: {
                none: 'Aucune',
                primary: 'Primaire',
                secondary: 'Secondaire',
                tertiary: 'Tertiaire'
            },
            fields: {
                customerColorIndex: 'Couleur du client'
            }
        },

        background: {
            menu: {
                none: 'Aucun',
                color: 'Uni',
                gradient: 'Dégradé'
            },

            addColor: {
                label: 'Ajouter couleur'
            },

            gradient: {
                fields: {
                    percent: 'A partir de'
                }
            }
        },

        layer: {
            remove: {
                confirmation: {
                    message: 'Êtes-vous sûr de vouloir supprimer cet élément ?'
                },
                all: {
                    label: 'Tout supprimer'
                }
            }
        },
        children: {
            defaultName: 'Page { position }',
            remove: {
                confirmation: {
                    message: 'Êtes-vous sûr de vouloir supprimer cette page ?'
                }
            }
        },

        contextualMenu: {
            button: {
                group: {
                    label: 'Grouper'
                },
                ungroup: {
                    label: 'Dégrouper'
                }
            }
        }
    }

};
